import React from "react";
import { useNavigate } from "react-router-dom";
import { useYouTubeConnection } from "../hooks/useYouTubeConnection";
import ChannelSelection from "./ChannelSelection";

const YouTubeCallback: React.FC = () => {
  const navigate = useNavigate();
  const { loading, error, accessToken, refreshToken, email, channels } =
    useYouTubeConnection();

  const handleClose = () => {
    navigate("/social-posts?tab=connect");
  };

  const handleSuccess = () => {
    // Success will be handled in the channel selection component
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="spinner w-12 h-12 border-4 border-t-4 border-gray-200 border-t-brand-primary rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Connecting to YouTube...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
          <div className="text-red-600 mb-4">
            <svg
              className="w-12 h-12 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </div>
          <h2 className="text-xl font-bold text-center mb-4">
            Connection Error
          </h2>
          <p className="text-gray-600 text-center mb-6">{error}</p>
          <div className="flex justify-center">
            <button
              onClick={() => navigate("/social-posts?tab=connect")}
              className="px-4 py-2 bg-brand-primary text-white rounded-md hover:bg-brand-primary-hover"
            >
              Back to Connections
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <ChannelSelection
      channels={channels}
      accessToken={accessToken}
      refreshToken={refreshToken}
      email={email}
      onClose={handleClose}
      onSuccess={handleSuccess}
    />
  );
};

export default YouTubeCallback;
